import { TFunction } from 'i18next';

import { uiHelpers } from '../../../helpers';
import {
  ExternalSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';

interface HSIDividend {
  date: string;
  dividend: number;
  updateTime: number;
}

class HSIDividend extends ExternalSeriesGenerator {
  yAxisFormatter = uiHelpers.formatPercentage;
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = false;
  height = -1;

  data: HSIDividend[];
  constructor(t: TFunction, data: HSIDividend[]) {
    super(t);
    this.data = data;
  }

  getChartName(): string {
    let updateTime;
    if (this.data.length > 0) {
      updateTime = [...this.data]
        .reverse()
        .find(data => data.updateTime)?.updateTime;
    }
    if (updateTime) {
      return (
        this.t('HSIDividend') +
        ' ' +
        this.t('Updated at') +
        ' ' +
        uiHelpers.formatDateTimeLocalFromTimestamp(updateTime)
      );
    }
    return this.t('HSIDividend');
  }

  getSeries(): PriceViewerSeries[] {
    const hsiDividend = [];
    for (const item of this.data) {
      hsiDividend.push([item.date, item.dividend / 100]);
    }
    return [
      {
        name: this.t('dividend-yield'),
        echartSeries: {
          type: 'line',
          connectNulls: true,
          data: hsiDividend,
          symbol: 'none',
          lineStyle: {
            color: '#039BE5',
          },
        },
        tooltipFormatter: getDefaultToolptipFormatter('2d', 'percentage', {
          keyColor: '#039BE5',
        }),
      },
    ];
  }
}

export default HSIDividend;
